const Preferences = () => {
  return (
    <>
      <h2>Preferences</h2>
    </>
  );
};

export default Preferences;
